import * as yup from "yup";
import {endOfDay, startOfDay} from "date-fns";

const getValidationSchema = (booking, guests) => {
    return yup.object().shape({
        checkInDate: yup
            .string()
            .typeError('Campo non valido')
            .required('Campo obbligatorio')
            .test('after-booking-arrival',
                'La data di Check-In deve essere successiva o uguale alla data di arrivo della prenotazione',
                value => {
                    if (!value) return false;
                    const checkIn = new Date(value);
                    return checkIn >= startOfDay(booking.getArrival());
                }
            ),
        expectedCheckOutDate: yup
            .string()
            .typeError('Campo non valido')
            .required('Campo obbligatorio')
            .test('after-check-in-date',
                'La data di Check-Out deve essere successiva alla data di Check-In',
                function (value) {
                    const {checkInDate} = this.parent;
                    if (!value || !checkInDate) return false;
                    const checkIn = new Date(checkInDate);
                    const checkOut = new Date(value);
                    return checkOut > endOfDay(checkIn);
                }
            )
            .test('before-booking-departure',
                'La data di Check-Out deve essere antecedente alla data di partenza della prenotazione',
                value => {
                    if (!value) return false;
                    const checkOut = new Date(value);
                    return checkOut <= endOfDay(booking.getDeparture());
                }
            ),
        excludedGuests: yup
            .array()
            .max(guests.length - 1, 'Devi selezionare almeno un ospite per procedere con il check in')
            .test('one-document-id',
                `Per caricare le schedine sul servizio Alloggiati, devi inserire almeno ${ booking.alloggiatiDocumentsRequired  <= 1 ? 'un ospite' : `${booking.alloggiatiDocumentsRequired} ospiti`} con documento d'identità`,
                (value, testContext) => {
                    const {syncAlloggiati} = testContext.parent;

                    if (!syncAlloggiati) {
                        return true;
                    }
                    const guestsWithDocument = guests.filter(g => !value.includes(g.id)).filter(g => g.hasIdDocument()).length;
                    return guestsWithDocument >= booking.alloggiatiDocumentsRequired
                }
            )
            .typeError('Campo non valido')
            .required('Campo obbligatorio')
    })
}

export default getValidationSchema;